import React from 'react';
import { useParams } from 'react-router-dom';
import ArticlePageTemplate from '../../components/seo/ArticlePageTemplate';
import ArticleLegacyRedirect from './ArticleLegacyRedirect';
import NotFoundPage from '../NotFoundPage';
import { getArticleBySlug } from '../../data/contentRegistry';
import SEO_REDIRECTS from '../../data/seoRedirects.json';

export default function ArticleDispatcher() {
  const { slug } = useParams();

  if (SEO_REDIRECTS[slug]) {
    return <ArticleLegacyRedirect slug={slug} />;
  }

  const registryArticle = getArticleBySlug(slug);
  if (registryArticle) {
    return <ArticlePageTemplate content={registryArticle} />;
  }

  return <NotFoundPage />;
}
